import React, { useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, Map, Building2, ArrowLeft } from 'lucide-react';

// IMPORT YOUR COMPONENTS HERE (Adjust paths to match your folder structure)
import { Document } from '../document/document';
import { VillageS } from '../village/village_select'; // Your Zone Management component
import { Branch } from '../branch/branch';

export const Resource = () => {
  // State to manage which view is currently open ('cards', 'document', 'zone', 'branch')
  const [activeView, setActiveView] = useState('cards');

  // Array to map through for generating the cards cleanly
  const resourceCards = [
    { 
      id: 'document', 
      title: 'Document Management', 
      icon: FileText, 
      desc: 'Upload, verify, and organize system documents.', 
      variant: 'primary',
      bgClass: 'bg-primary-subtle text-primary' 
    },
    { 
      id: 'zone', 
      title: 'Zone Management', 
      icon: Map, 
      desc: 'Configure and oversee geographic operational zones.', 
      variant: 'success',
      bgClass: 'bg-success-subtle text-success'
    },
    { 
      id: 'branch', 
      title: 'Branch Management', 
      icon: Building2, 
      desc: 'Add, edit, and monitor branch locations and geofences.', 
      variant: 'warning',
      bgClass: 'bg-warning-subtle text-warning'
    }
  ];

  return (
    <div className="resource-container p-2">
      <AnimatePresence mode="wait">
        
        {/* VIEW 1: THE 3 CARDS */}
        {activeView === 'cards' ? (
          <motion.div
            key="cards-view"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            <h4 className="mb-4 text-muted fw-bold">Resource Center</h4>
            <Row className="g-4">
              {resourceCards.map((card) => (
                <Col md={4} key={card.id}>
                  <Card className="h-100 shadow-sm border-0 rounded-4 custom-hover-card">
                    <Card.Body className="p-4 d-flex flex-column align-items-center text-center">
                      
                      {/* Icon Circle */}
                      <div 
                        className={`rounded-circle d-flex align-items-center justify-content-center mb-3 ${card.bgClass}`} 
                        style={{ width: '70px', height: '70px' }}
                      >
                        <card.icon size={32} />
                      </div>
                      
                      <Card.Title className="fw-bold mb-2">{card.title}</Card.Title>
                      <Card.Text className="text-muted small mb-4 flex-grow-1">
                        {card.desc}
                      </Card.Text>
                      
                      <Button 
                        variant={`outline-${card.variant}`} 
                        className="w-100 rounded-pill fw-medium"
                        onClick={() => setActiveView(card.id)}
                      >
                        Open {card.title}
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </motion.div>
        ) : (
          
          /* VIEW 2: THE TABLES/COMPONENTS */
          <motion.div
            key="component-view"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            {/* Back Button Header */}
            <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
              <Button 
                variant="light" 
                className="d-flex align-items-center gap-2 me-3 shadow-sm"
                onClick={() => setActiveView('cards')}
              >
                <ArrowLeft size={18} /> Back to Resources
              </Button>
              <h5 className="mb-0 text-capitalize fw-bold text-muted">
                {activeView} Management
              </h5>
            </div>

            {/* Render the specific component based on state */}
            <div className="component-wrapper">
              {activeView === 'document' && <Document />}
              {activeView === 'zone' && <VillageS />}
              {activeView === 'branch' && <Branch />}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};